<template lang="pug">
    el-popover(
        popper-class="wam-select wam-select__dropdown"
        class="wam-select"
        :class="{ disabled }"
        placement="bottom"
        v-model="visible"
        width="180"
        trigger="click"
        :visible-arrow="false")
        div   
            .wam-select__label(v-if="label")
                svg-icon(v-if="icon" :name="icon" size="small")
                | {{ label }}
            .wam-select__dropdown--container
                el-slider(
                    range
                    :disabled="disabled"
                    :value="value"
                    @input="handleChange($event)"
                    :min="1"
                    :max="20"
                    :marks="{ 1: '1', 20: { style: { width: 'max-content'}, label: '20+'}}")
                p(v-if="disabled && disabledMessage") {{ disabledMessage }}
        button.wam-select__button(
            :class="buttonClass"
            :disabled="disabled"
            slot="reference"
            v-html="getValueName")
</template>

<script>
import wamSelectMixin from './mixin'

export default {
    name: 'WamSelectRange',

    mixins: [wamSelectMixin],

    props: {
        min: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        marks: {
            type: Object,
            default: () => ({})
        },
        disabledMessage: {
            type: String,
            default: ''
        }
    },

    data : () => ({
        visible: false
    }),
    watch: { 
        '$route': {
            handler: function() {
                if (this.visible) this.visible = false
            },
            deep: true
        }
    }
}
</script>
